import React, { Component } from 'react';
// import profileImg from "../../../../utils/images/profileImg.png";
/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class ActiveVisitPatientInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isParent: true,
            studentName: '',
            grade: 0,
            studentDetails: {},
            kidName: '',
        };
    }

    //componentDidMount
    componentDidMount() {
        this.props.invokeKidInfo();
    }

    render() {
        const { videoCallDetails, streams } = this.props;
        const {
            patientName,
            doctorName,
            //  profileImage
        } = videoCallDetails;
        const [streamsAudio] = streams;
        const sessionType = sessionStorage.getItem('SESSION_TYPE');
        const isInPersonOneToOne = sessionType === 'IN_PERSON';
        const streamNames = streams?.map((stream) => stream.name);
        const currentUserId = JSON.parse(sessionStorage.getItem('userSession'))?.id;

        const oldDisplayName =
            this.props.studentDetails?.tutor?.userId === currentUserId ? patientName : doctorName;

        const validStreamNames = streamNames?.filter(
            (name) => name && name !== 'Educator' && name !== 'screen'
        );

        const streamDisplayName = validStreamNames?.[0];

        let finalDisplayName = '';

        if (streamDisplayName && streamDisplayName !== oldDisplayName) {
            finalDisplayName = streamDisplayName;
        } else if (oldDisplayName && oldDisplayName !== 'Educator') {
            finalDisplayName = oldDisplayName;
        }

        return (
            <>
                {/* {this.props.showBoard && ( */}
                <div className="text-white bg-dateselect">
                    {sessionStorage.getItem('VISIT_TYPE') === 'one_to_one' ? (
                        <div className="flex items-center justify-between p-3 flex-view">
                            <div className="flex items-center justify-between w-full gap-3 m-3">
                                <div>
                                    <p>
                                        <b
                                            className="truncate block max-w-[200px]"
                                            title={finalDisplayName}
                                        >
                                            {finalDisplayName}
                                        </b>
                                    </p>
                                </div>

                                {!isInPersonOneToOne && (
                                    <div className="relative">
                                        {streams?.length !== 0 && streamsAudio?.hasAudio && (
                                            <span className="absolute inline-flex w-8 h-8 bg-green-400 rounded-full opacity-75 animate-ping"></span>
                                        )}
                                        {/* <img
                      className="h-full max-w-full circle-img"
                      src={profileImage ? profileImage : profileImg}
                      alt=""
                    /> */}
                                        <span
                                            className={`relative inline-flex h-8 w-8 rounded-full items-center justify-center ${
                                                streams?.length === 0 || streamsAudio?.hasAudio
                                                    ? 'bg-green-500 text-white'
                                                    : 'bg-red-500 text-white'
                                            }`}
                                        >
                                            <i
                                                className={`fa-sm ${
                                                    streams?.length === 0 || streamsAudio?.hasAudio
                                                        ? 'far fa-microphone'
                                                        : 'fas fa-microphone-slash'
                                                }`}
                                            />
                                        </span>
                                    </div>
                                )}
                            </div>
                            <div className="flex-component">
                                {this.props._renderAddress(videoCallDetails)}
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                {/* )} */}
            </>
        );
    }
}

export default ActiveVisitPatientInformation;
